<h2 mat-dialog-title class="headerCustomTitlePopup">
  {{ (mode === 'create' ? 'CALENDAR.GOOGLE.NEW' : 'CALENDAR.GOOGLE.EVENT') | translate }}
</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="row g-3">
    @if (mode === 'create') {
      <div class="col-12">
        <label class="form-label" for="googleCalendar">{{ 'CALENDAR.GOOGLE.CALENDAR' | translate }}</label>
        <select id="googleCalendar" class="form-select" formControlName="calendar_id">
          @for (calendar of writableCalendars; track calendar.id) {
            <option [value]="calendar.id">{{ calendar.name }}</option>
          }
        </select>
        @if (writableCalendars.length === 0) {
          <div class="form-text">{{ 'CALENDAR.GOOGLE.NO_WRITABLE' | translate }}</div>
        }
      </div>
    } @else {
      <div class="col-12">
        <span class="text-muted">{{ 'CALENDAR.GOOGLE.CALENDAR' | translate }}</span>
        <div>{{ data.event?.calendar_name }}</div>
      </div>
    }
    <div class="col-12">
      <label class="form-label" for="googleTitle">{{ 'CALENDAR.POPUP.TITLE' | translate }}</label>
      <input id="googleTitle" class="form-control" formControlName="title" maxlength="500">
    </div>
    <div class="col-12">
      <label class="form-label" for="googleDescription">{{ 'CALENDAR.POPUP.DESCRIPTION' | translate }}</label>
      <textarea id="googleDescription" class="form-control" rows="3" formControlName="description"></textarea>
    </div>
    <div class="col-12">
      <label class="form-label" for="googleLocation">{{ 'CALENDAR.GOOGLE.LOCATION' | translate }}</label>
      <input id="googleLocation" class="form-control" formControlName="location" maxlength="500">
    </div>
    <div class="col-12">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="googleAllDay" formControlName="isallday">
        <label class="form-check-label" for="googleAllDay">{{ 'CALENDAR.POPUP.ALLDAY' | translate }}</label>
      </div>
    </div>
    <div class="col-md-6">
      <label class="form-label" for="googleStart">{{ 'CALENDAR.POPUP.STARTDATE' | translate }}</label>
      <input id="googleStart" type="date" class="form-control" formControlName="date_start">
    </div>
    <div class="col-md-6">
      <label class="form-label" for="googleEnd">{{ 'CALENDAR.POPUP.ENDDATE' | translate }}</label>
      <input id="googleEnd" type="date" class="form-control" formControlName="date_end">
    </div>
    @if (!form.get('isallday')?.value) {
      <div class="col-md-6">
        <label class="form-label" for="googleTimeStart">{{ 'CALENDAR.POPUP.STARTTIME' | translate }}</label>
        <input id="googleTimeStart" type="time" class="form-control" formControlName="time_start">
      </div>
      <div class="col-md-6">
        <label class="form-label" for="googleTimeEnd">{{ 'CALENDAR.POPUP.ENDTIME' | translate }}</label>
        <input id="googleTimeEnd" type="time" class="form-control" formControlName="time_end">
      </div>
    }
    @if (form.hasError('required') || form.get('time_start')?.invalid || form.get('time_end')?.invalid || form.hasError('dateRangeInvalid') || form.hasError('timeRangeInvalid')) {
      <div class="col-12 text-danger small">{{ 'CALENDAR.GOOGLE.INVALID_TIME' | translate }}</div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.event?.html_link) {
    <a class="btn btn-link me-auto" [href]="data.event?.html_link" target="_blank" rel="noopener noreferrer">
      {{ 'CALENDAR.GOOGLE.OPEN' | translate }}
    </a>
  }
  @if (mode === 'edit') {
    <button type="button" class="btn btn-outline-danger" [disabled]="saving" (click)="remove()">
      {{ 'CALENDAR.GOOGLE.DELETE' | translate }}
    </button>
  }
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ 'CALENDAR.POPUP.CLOSE' | translate }}
  </button>
  @if (mode !== 'view') {
    <button type="button" class="btn btn-primary" [disabled]="saving || (writableCalendars.length === 0 && mode === 'create')" (click)="save()">
      {{ 'CALENDAR.POPUP.SAVE' | translate }}
    </button>
  }
</mat-dialog-actions>
